import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as AOS from 'aos';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'jahe';

  public isloading : boolean;
  private currentPath:any;
  private routerListener:any;

  constructor(
    private router: Router,
  ){
    this.isloading = true;
    this.pageLoadListener();
  }

  ngAfterViewInit(){
    this.isloading = true;
    this.sleep();
  }

  async sleep(){
    await new Promise(resolve => setTimeout(resolve, 2000));
    this.isloading = false;
    AOS.init();
  }

  pageLoadListener() {
    this.routerListener = this.router.events.subscribe(($e) => {
      if ($e instanceof NavigationEnd) {
        // AOS.refresh();
        if(this.currentPath !== $e.url){
          this.isloading = true;
          this.sleep();
          this.currentPath = $e.url;
          window.scroll(0,0)
        }        
      }
    })
  }
}

